// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2405":"bc5d0f0f","2485":"79a0f060","6378":"1b4bcca1","7212":"f2d44e4f","7528":"20b10e5c"}[chunkId] + ".chunk.css";
};